import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { AccountType } from '../../enums/AccountType';

// 借助 createSlice 创建 reducer、action
const AccountTypeSlice = createSlice({
    name: 'accountType',
    initialState: {
        value: AccountType.Default,
    },
    reducers: {
        setAccountType: (state, action: PayloadAction<AccountType>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setAccountType } = AccountTypeSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const accountTypeSelector = (state: RootState) => state.accountType.value;

// Reducer，真正执行修改 state 的纯函数
export default AccountTypeSlice.reducer;
